module.exports = __webpack_public_path__ + "img/icons8-registry-editor-100 1 copy.0fce767b.svg";